"use strict";
export const GridMock = (mock) => {
  mock.onGet("/api/v7/accounts/dashboard_all_for_client").reply((config) => {
    let response = {
      "model": "dashboard.client",
      "all_vd": 1,
      "need_renew_vd": 1,
      "current_icon": 990,
      "simple_risk": 0,
      "danger_risk": 0,
      "discount_coupon": 1,
      "shop": 8
    };
    return [200, response];
  });
};
